export default "__VITE_ASSET__FtDatlhQ__"